module.exports = __webpack_public_path__ + "static/media/gts22.017bf72f.png";